import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';

import boTheme from '@ecp/common/src/style/theme/bo';
import { FlexBox } from '@ecp/common/src/layouts/flex/styled';
import { Spacing } from '@ecp/common/src/layouts/Spacing';
import { TextBox } from '@ecp/common/src/text/TextBox';
import Button from '@ecp/common/src/components/button/bo/Button';

import useContentsLayout from '@bo-hooks/common/useContentsLayout';
import InfoTextBox from '@bo-components/promotion/InfoTextBox';
import { SITE_STATUS, TERMINATED } from './consts/SiteConst';
import DetailSiteBasicInfo from './components/DetailSiteBasicInfo';
import DetailSiteConfigInfo from './components/DetailSiteConfigInfo';
import DetailTermInfo from './components/DetailTermInfo';
import DetailDisplayInfo from './components/DetailDisplayInfo';
import DetailImageInfo from './components/DetailImageInfo';
import { useDetailHooks } from './hooks/SiteManagementDetailHooks';
import ContentsUtility from '@bo-layout/contents/ContentsUtility';
import ContentsPageInformation from '@bo-layout/contents/ContentsPageInformation';

const SiteManagementDetail = () => {
  useContentsLayout({
    title: '사이트상세',
    backPath: '/system/site-management-minor',
  });
  const { id: siteNumber } = useParams();

  const {
    welmallInfo,
    redirectUrlList,
    jobGroupList,
    subsidiaryList,
    applyExceptPayMeanList,
    siteMemberCnt,
    siteDisplay,
    siteBasicInfo,
    siteTermList,
    audit,
    handleRefreshSiteInfo,
    handleRefreshDisplay,
    handleRefreshTerm,
    moveSite,
  } = useDetailHooks({ siteNumber });

  const hasTemplate = useMemo(() => siteDisplay.hasMainTemplate && siteDisplay.hasDisplayTemplate, [siteDisplay]);

  return (
    <>
      <ContentsPageInformation audit={audit} />
      <DetailSiteBasicInfo
        siteBasicInfo={siteBasicInfo}
        subsidiaryList={subsidiaryList}
        jobGroupList={jobGroupList}
        redirectUrlList={redirectUrlList}
        applyExceptPayMeanList={applyExceptPayMeanList}
        siteMemberCnt={siteMemberCnt}
      />
      <Spacing top={10} width={'100%'} />
      <DetailSiteConfigInfo
        siteBasicInfo={siteBasicInfo}
        welmallCustCenter={welmallInfo}
        footerAppDownloadUseYn={siteBasicInfo.footerAppDownloadUseYn || 'N'}
        handleFormChange={() => {}}
        disableEdit
        refreshCustomerCenter={handleRefreshSiteInfo}
      />
      <Spacing top={10} width={'100%'} />
      <DetailImageInfo
        siteBasicInfo={siteBasicInfo}
        welmallInfo={welmallInfo}
        refreshSiteInfo={handleRefreshSiteInfo}
      />
      <Spacing top={10} width={'100%'} />
      <FlexBox width={'100%'} align-items={'flex-start'}>
        <DetailTermInfo siteTermList={siteTermList} refreshTerm={handleRefreshTerm} />
        <Spacing left={10} />
        <DetailDisplayInfo siteDisplay={siteDisplay} handleRefreshClick={handleRefreshDisplay} />
      </FlexBox>
      <ContentsUtility>
        <FlexBox width={'100%'} justify-content={'space-between'}>
          <FlexBox>
            {siteBasicInfo.siteStatCode !== TERMINATED && (
              <>
                <Button type={'Third'} disabled={!hasTemplate} onClick={moveSite}>
                  사이트이동
                </Button>
                <Spacing left={14} />
                <InfoTextBox>메인템플릿과 전시카테고리가 등록완료되어야 사이트이동이 가능합니다.</InfoTextBox>
              </>
            )}
          </FlexBox>
          <FlexBox>
            <TextBox font-size={'13px'} color={boTheme.color.sub1}>
              {SITE_STATUS[siteBasicInfo.siteStatCode]}
            </TextBox>
          </FlexBox>
        </FlexBox>
      </ContentsUtility>
    </>
  );
};

export default SiteManagementDetail;
